import React from "react";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import Button from "../../atoms/button/button";
import MediaCard from "../../molecules/media-card/mediaCard";
import TitleSection from "../../molecules/title-section";
import { Link, useStaticQuery, graphql } from "gatsby";

import "./reliveWrapper.scss";

const ReliveCardWrapper = (props: ReferenciaContenido) => {

    const data = useStaticQuery(graphql`
    query RELIVEDATA {
        dataSub: contentfulSubcategorias(contentful_id: {eq: "2SmuRXdJp2FuOoTdiVoL5D"}) {
            referenciaSubcategorias {
                slug
                referenciaInterna {
                    referenciaContenido {
                        contentful_id
                    }
                    referenciaCabecera {
                        migaDePan
                        referenciaMultimedia {
                            audioUrl
                            autor
                            categoriaMultimedia
                            contentful_id
                            createdAt
                            descripcion {
                                raw
                            }
                                imagenPrincipal {
                                    gatsbyImageData(
                                        layout: CONSTRAINED
                                        outputPixelDensities: [0.5, 1, 2]
                                        breakpoints: [320, 768, 1024, 1440]
                                        placeholder: BLURRED
                                        sizes: "(max-width: 320px) 320px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 1440px"
                                    )
                                    description                                    
                                }
                            nuevoContenido
                            tematica
                            textoIntroductorio
                            tiempoLectura
                            tituloBoton
                            tituloMultimedia
                            videoUrl
                            video {
                                file {
                                    url
                                    fileName
                                    contentType
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    `);

    const transformData = (arr) => {
        let auxList = arr.map((sub) => {
            return {
                ...sub.referenciaInterna.referenciaCabecera.referenciaMultimedia,
                slug: sub.slug,
                parentContentfulId: sub.referenciaInterna.referenciaContenido[0].contentful_id
            }
        })
        return auxList;
    }
    const mediaCards = transformData(data.dataSub.referenciaSubcategorias);
    const filterList = mediaCards.filter(item => item.categoriaMultimedia == "Webinar");
    const lastPublish = filterList.map(obj => { return { ...obj, date: new Date(obj.createdAt) } }).sort((a:any, b: any) => a.date - b.date).reverse();
    const itemsPublished = lastPublish.length >= 1 ? lastPublish : mediaCards;

    return (
        <>
           <div className="o-learning-section-cmnd-relive">
              <TitleSection title={props.tituloGeneral} introText=""/>
              <div className="o-learning-section-cmnd-relive__cards">
                <div className="o-learning-section-cmnd-relive__cards-left">
                    {itemsPublished.map((item, index) => (
                        index == 0 ?
                            <MediaCard 
                                tituloMultimedia={item.tituloMultimedia}
                                descripcion={item.descripcion}
                                imagenPrincipal={item.imagenPrincipal}
                                tituloBoton={item.tituloBoton}
                                tematica={item.tematica}
                                categoriaMultimedia={item.categoriaMultimedia}
                                nuevoContenido={item.nuevoContenido}
                                textoIntroductorio={item.textoIntroductorio}
                                slug={`./biblioteca/${item.slug}`}
                                parentContentfulId={item.parentContentfulId}
                            />
                            :
                            null
                    ))}
                </div>
                <div className="o-learning-section-cmnd-relive__cards-right">
                    {itemsPublished.map((item, index) => (
                        index == 1 || index == 2 ?
                            <MediaCard 
                                tituloMultimedia={item.tituloMultimedia}
                                descripcion={item.descripcion}
                                imagenPrincipal={item.imagenPrincipal}
                                tituloBoton={item.tituloBoton}
                                tematica={item.tematica}
                                categoriaMultimedia={item.categoriaMultimedia}
                                nuevoContenido={item.nuevoContenido}
                                textoIntroductorio={item.textoIntroductorio}
                                slug={`./biblioteca/${item.slug}`}
                            />
                            :
                            null
                    ))}
                </div>
              </div>
              <div className="o-learning-section-cmnd-relive__buttons">
                <Link to={props.redireccionBoton}>
                    <Button
                        type="link"
                        text={props.tituloBoton}
                        classname={`a-button__magenta gtm_ir_a_la_biblioteca_comunidades_home`}
                        isDisabled={false}
                        href={void(0)}
                    />
                </Link>
              </div>
            </div>
        </>
    );
};

export default ReliveCardWrapper;
